import apiService from "../ApiService";

export const ubisoftRevoke = () => {
  return apiService.deleteApi<void>({
    path: "v1/store/ubisoft/auth/revoke",
  });
};
